<template>
<div>
    <!-- nav -->
    <header-bar></header-bar>
    <!-- body -->
    <div class="container-fluid full-content page" style="margin: 70px 50px 0;">
      <div v-html="content" />
    </div>
    <footerBar></footerBar>

    <login :isLogin="isLogin" @loginVisible="loginVisible()" @loginSuccess="loginSuccess"></login>
</div>
</template>

<script>
import headerBar from './header/Header'
import footerBar from './footer/Footer'
import $H from '@/common/request.js'
import login from './login/Login'
export default {
  name: 'contact',
  components: {
    headerBar,
    footerBar,
    login
  },
  data () {
    return {
      title: '',
      content: '',
      isLogin: false,
      hasLogin: false
    }
  },
  mounted () {
    let user = localStorage.getItem('loginUser')
    let loginTime = localStorage.getItem('loginTime')
    if (user) {
      console.log(user)
      user = JSON.parse(user)
      if (loginTime) {
        let time = Math.round(new Date().getTime() / 1000)
        if (time - Number(loginTime) > 86400) {
          this.hasLogin = false
        } else {
          if (user.access_token) {
            this.hasLogin = true
            this.user = user
          }
        }
      }
    }
    if (!this.hasLogin) {
      this.$message.error('请先登录！')
      this.isLogin = true
      return
    }
    $H.get('/notice').then(res => {
      this.title = res.title
      this.content = res.content

      document.title = res.title + ' - 来找刊'
    })
  },
  methods: {
    loginVisible () {
      this.isLogin = false
    },
    loginSuccess () {
      this.isLogin = false
      this.hasLogin = true
      let user = localStorage.getItem('loginUser')
      let loginTime = localStorage.getItem('loginTime')
      if (user) {
        console.log(user)
        user = JSON.parse(user)
        if (loginTime) {
          let time = Math.round(new Date().getTime() / 1000)
          if (time - Number(loginTime) > 86400) {
            this.hasLogin = false
          } else {
            if (user.access_token) {
              this.hasLogin = true
              this.user = user
            }
          }
        }
      }
      location.reload()
    }
  }
}
</script>
<style >
.container-fluid{
  margin-top: 70px;
}
.address{
    padding: 20px;
    width: 1000px;
    margin: 0 auto;
    margin-top:70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue